import React, { useState, useEffect } from "react";
import enUS from "../../../data/en-US";
import { useLanguageContext } from "../../../context/languageContext";
import { fakedb } from "../../../data/fakedb";
import Card04 from "../../cards/Card04";
import Button from "../../buttons/Button";

const NewsSection = () => {
    const { language } = useLanguageContext();
    const [ data, setData ] = useState();
    const info = {
        'en-US': enUS
    }
    useEffect(() => {
        setData(info[language].homepage.news)
    })

    return (
        <div className="news-section-wrapper font-face-poppins">
            <div className="themesflat-container">
                <div className="news-section-title font-face-pop text-center">
                    { data && data.heading}
                </div>
                <div className="news-section-body text-center">
                    { data && data.body}
                </div>
                <div className="news-section-show">
                    {
                        fakedb.news_top_5.slice(0,5).map((item, index) => (
                            <div key={index}>
                                <Card04 item={item} index={index}/>                          
                            </div>
                        ))
                    }
                </div>
                <div className="news-section-footer text-right">
                    <Button
                        width={276}
                        height={48}
                        text={ data && data.footer.button }
                        borderRadius="9"
                        fontSize="1.2em"
                    />
                </div>
            </div>
        </div>
    )
}

export default NewsSection;